<template>
  <div class="father" style="">
    <div class="div-main-father" style="">
      <!-- 手机 -->
      <div class="div-main-son" style="">
        <div class="div-main-sonson background-img" style="">
          <div class="div-camera"></div>
          <div class="div-other-camera">
            <div class="div-other-img" :style="(bg_color && !bg_style) || bg_style ? bg_color : bg_style">
              <img class="bg-img" v-if="bg_src" :src="bg_src" alt="" />
              <div class="div-other-img-top">
                <div style="display: flex">
                  <div class="img-icon" style="">
                    <img :src="member_card.base_info.logo_url" v-if="member_card.base_info.logo_url" alt=""
                      class="img-icon" />
                  </div>
                  <div style="margin-right: 20px; display: inline">
                    <span style="color: #fff; font-weight: 400; font-size: 16px">
                      {{ member_card.base_info.brand_name }}
                    </span>
                    <span style="
                        color: #fff;
                        font-weight: 200;
                        font-size: 12px;
                        margin-top: 3px;
                      ">{{ member_card.base_info.title }}</span>
                  </div>
                </div>
                <div style="
                    position: absolute;
                    top: 0;
                    right: 20px;
                    display: inline-block;
                    width: 30px;
                    height: 30px;
                    border-radius: 5px;
                  ">
                  <i class="iconfont icon-erweima" style="color: #fff; font-size: 30px"></i>
                </div>
              </div>
              <!-- id号 -->
              <div class="div-other-img-btm" style="
                  position: absolute;
                  width: 100%;
                  height: 30px;
                  margin-top: 68px;
                  line-height: 2;
                  padding-left: 10px;
                ">
                <div style="
                    color: #fff;
                    display: inline-block;
                    margin-right: 130px;
                  ">
                  {{ "XXXXXXXXXXX" }}
                </div>
                <!-- 感叹号 -->
                <div class="div-other-img-btm-icon" style="">
                  <!-- <i class="el-icon-warning-outline"></i> -->
                </div>
              </div>
            </div>
            <!-- 中部三 -->
            <div class="div-other-center" style="">
              <div class="div-other-center-items" style="">
                <div style="">
                  <i style="display: block; font-size: 10px; color: #ccc">积分</i><i
                    style="font-size: 16px; color: rgb(3, 222, 3)">100</i>
                </div>
              </div>
              <div class="div-other-center-items">
                <div style="">
                  <i style="display: block; font-size: 10px; color: #ccc">余额</i><i
                    style="font-size: 16px; color: rgb(3, 222, 3)">查看</i>
                </div>
              </div>
              <div class="" style="
                  display: inline-block;
                  width: 33%;
                  height: 96%;
                  margin-top: 1px;
                  line-height: 2;
                  text-align: center;
                ">
                <div style="">
                  <i style="display: block; font-size: 10px; color: #ccc">优惠卷</i><i
                    style="font-size: 16px; color: rgb(3, 222, 3)">详情</i>
                </div>
              </div>
            </div>
            <!-- 中部按钮 -->
            <div style="text-align: center">
              <el-button class="el-button-green" disabled style="
                  height: 38px;
                  width: 150px;
                  color: rgb(3, 222, 3);
                  border: 1px soild green !important;
                ">
                {{ member_card.base_info.center_title }}
              </el-button>
              <span style="
                  height: 15px;
                  font-size: 12px;
                  color: #ccc;
                  margin-top: 5px;
                ">{{ member_card.base_info.center_sub_title }}</span>
            </div>
            <!-- custom_url_name: "", //跳转外链的名字            ❤
          custom_url: "", //url
          custom_url_sub_title: "", //显示在路口右侧的提示
          promotion_url_name: "", //营销场景自定义入口
          promotion_url: "", //入口跳转外链的地址链接
          promotion_url_sub_title: "", //显示在营销入口右侧的提示语。 -->
            <div v-if="
              member_card.base_info.custom_url_name ||
              member_card.base_info.custom_url_sub_title
            " :class="member_card.base_info.custom_url_name
              ? 'el-herf'
              : 'el-herf-right'
              " style="border-top: 1px solid #f1f1f1; margin-top: 10px">
              {{ member_card.base_info.custom_url_name }}
              <span style="color: rgb(187 187 187)">
                <i style="font-style: none; margin-right: 10px; font-size: 14px">{{
                  member_card.base_info.custom_url_sub_title }} </i>></span>
            </div>

            <div v-if="
              member_card.base_info.promotion_url_name ||
              member_card.base_info.promotion_url_sub_title
            " :class="member_card.base_info.promotion_url_name
              ? 'el-herf'
              : 'el-herf-right'
              " :style="member_card.base_info.custom_url_name ||
                member_card.base_info.custom_url_sub_title
                ? ''
                : 'border-top:1px solid #f1f1f1;margin-top:10px'
                ">
              {{ member_card.base_info.promotion_url_name }}
              <span style="color: rgb(187 187 187)"><i style="font-style: none; margin-right: 10px; font-size: 14px">{{
                member_card.base_info.promotion_url_sub_title }}</i>></span>
            </div>

            <div class="el-herf" :style="member_card.base_info.custom_url_name ||
              member_card.base_info.custom_url_sub_title ||
              member_card.base_info.promotion_url_name ||
              member_card.base_info.promotion_url_sub_title
              ? ''
              : 'border-top:1px solid #f1f1f1;margin-top:10px'
              ">
              会员卡详情 <span style="color: rgb(187 187 187)">></span>
            </div>
            <div class="el-herf" style="">
              公众号 <span style="color: rgb(187 187 187)">></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 表单 -->
      <div class="div-main-form">
        <div class="form-top">
          <!-- 修改卡信息 -->
          会员卡信息修改（只填写需要修改的字段，不需要修改的可以不填）
        </div>
        <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 100%; margin: 5px">
          <el-form label-width="150px" label-position="left" style="width: 94%; margin: 10px 3% 0 3%">
            <el-form-item id="id-card" label="选择会员卡：" style="color: #dc1f1f">
              <el-radio-group v-model="gzhappid" @input="radioGroup($event, 'gzhappid')">
                <el-radio-button label="wxf003ddc051b4643b">快刷会员</el-radio-button>
                <el-radio-button label="wx59275b1f7f83e45f">测试公众号</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item id="id-card" label="选择会员卡：" style="color: #dc1f1f">
              <el-select v-model="wx_card_id" placeholder="选择需要修改的会员卡">
                <el-option v-for="item in cardOptions" :key="item.wx_card_id" :label="item.label"
                  :value="item.wx_card_id">
                </el-option>
              </el-select>
              选择需要修改的会员卡(必选)
            </el-form-item>
            <el-form-item label="LOGO：" style="padding-bottom: 20px">
              <logo :wh="'height:60px;width:60px;background-color:#80c4ff;font-size:20px'" :tag="'logo'" ref="logoRef"
                :uploadCommon="true" @getReturn="getReturn" @returnClose="returnClose">
                LOGO
              </logo>
            </el-form-item>

            <!-- <el-form-item label="商户名称：">
              <el-input
                v-model="member_card.base_info.brand_name"
                placeholder="设置会员卡名称，最高12个汉字。"
                maxlength="12"
                show-word-limit
              ></el-input>
            </el-form-item> -->
            <el-form-item label="卡卷名：">
              <el-input v-model="member_card.base_info.title" placeholder="设置会员卡名称，最高9个汉字。" maxlength="9"
                show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="卡片码类型：">
              <el-select v-model="member_card.base_info.code_type" placeholder="选择码类型">
                <el-option v-for="item in code_type_opetion" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- TODO: 一一键激活 -->
            <el-form-item label="一键开卡：">
              <el-switch @change="autoActivateChange" v-model="member_card.wx_activate" active-text="一键开卡"
                inactive-text="取消">
              </el-switch>
            </el-form-item>
            <!-- TODO: 一一键开卡 -->
            <el-form-item label="自动激活：">
              <el-switch v-model="member_card.auto_activate" active-text="自动激活" inactive-text="取消">
              </el-switch>
            </el-form-item>
            <!-- TODO: 外连接地址 -->
            <el-form-item label="激活链接：">
              <el-input v-model="member_card.activate_url" placeholder="设置激活链接" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="电话:">
              <el-input v-model="member_card.base_info.service_phone" show-word-limit maxlength="18"
                placeholder="请输入修改后的电话号码">
              </el-input>
            </el-form-item>
            <el-form-item label="背景颜色:">
              <el-select style="width: 200px" v-model="member_card.base_info.color" @change="setColor"
                placeholder="选择会员卡的背景颜色">
                <el-option v-for="item in colorOptions" :key="item.value" :label="item.label"
                  :style="`background-color:${item.color};`" style="color: #fff" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="背景图:" style="padding-bottom: 20px">
              <logo :wh="'height:160px;width:288.9px;background-color:#80c4ff;font-size:20px;'" :tag="'bg'"
                :uploadCommon="true" @getReturn="getReturn" @returnClose="returnClose">
                <div style="height:160px;width:288.9px'">上传背景图</div>
              </logo>
            </el-form-item>
            <el-form-item label="居中按钮:" style="margin-top: 130px">
              <el-input placeholder="卡卷居中按钮" v-model="member_card.base_info.center_title" maxlength="9"
                show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="中部按钮下方提示:">
              <el-input v-model="member_card.base_info.center_sub_title" placeholder="居中按钮下方提示" maxlength="18"
                show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="自定义路口一：">
              <el-input placeholder="" maxlength="5" show-word-limit v-model="member_card.base_info.custom_url_name">
                <template slot="prepend">名称</template>
              </el-input>
              <el-input placeholder="" v-model="member_card.base_info.custom_url" style="margin: 10px 0">
                <template slot="prepend">链接</template>
              </el-input>
              <el-input placeholder="" maxlength="6" show-word-limit
                v-model="member_card.base_info.custom_url_sub_title">
                <template slot="prepend">提示</template>
              </el-input>
            </el-form-item>
            <el-form-item label="自定义路口二：">
              <el-input placeholder="" maxlength="5" show-word-limit v-model="member_card.base_info.promotion_url_name">
                <template slot="prepend">名称</template>
              </el-input>
              <el-input placeholder="" v-model="member_card.base_info.promotion_url" style="margin: 10px 0">
                <template slot="prepend">链接</template>
              </el-input>
              <el-input placeholder="" maxlength="6" show-word-limit
                v-model="member_card.base_info.promotion_url_sub_title">
                <template slot="prepend">提示</template>
              </el-input>
            </el-form-item>

            <el-form-item label="使用提醒：">
              <el-input show-word-limit v-model="member_card.base_info.notice" placeholder="例：（付款时请提前出示会员卡）"
                maxlength="16">
              </el-input>
            </el-form-item>

            <!-- bonus_cleared:"", //积分清零规则 文字说明
        bonus_rules: "", //积分规则 文字说明
        balance_rules: "", //储值说明 -->
            <el-form-item label="积分清零规则：">
              <el-input type="textarea" style="width: 350px" resize="none" :rows="5" placeholder="填写会员积分的清空规则"
                v-model="member_card.bonus_cleared">
              </el-input>
            </el-form-item>

            <el-form-item label="储值说明：">
              <el-input type="textarea" style="width: 350px" resize="none" :rows="5" placeholder="会员卡储值功能的介绍"
                v-model="member_card.balance_rules">
              </el-input>
            </el-form-item>

            <el-form-item label="使用说明：">
              <el-input type="textarea" style="width: 350px" resize="none" :rows="5"
                placeholder="例：（会员卡每人限领1张，仅限本人使用卡卷使用说明）" v-model="member_card.base_info.description">
              </el-input>
            </el-form-item>
            <el-form-item label="会员卡特权说明：">
              <el-input type="textarea" style="width: 350px" resize="none" :rows="5"
                placeholder="例：（持会员卡消费送积分，可在商城兑换好礼）" v-model="member_card.prerogative">
              </el-input>
            </el-form-item>

            <el-form-item label="有效期：" style="color: #dc1f1f" v-if="false">
              <el-checkbox-group v-model="member_card.base_info.date_info.type" style="display: inline-block">
                <el-checkbox label="固定日期" value="1"></el-checkbox>
              </el-checkbox-group>
              <i style="margin-left: 20px">选择后开始结束日期必选</i>
            </el-form-item>
            <el-form-item v-if="member_card.base_info.date_info.type == '1'">
              <el-col :span="6">
                <div id="date-div">
                  <el-date-picker v-model="member_card.base_info.date_info.begin_timestamp"
                    @change="getDate($event, 'begin_timestamp')" type="date" placeholder="开始日期"></el-date-picker>
                </div>
              </el-col>
              <el-col :span="2" style="text-align: center">-</el-col>
              <el-col :span="6">
                <div id="date-div">
                  <el-date-picker v-model="member_card.base_info.date_info.end_timestamp" type="date"
                    @change="getDate($event, 'end_timestamp')" placeholder="截止日期"></el-date-picker>
                </div>
              </el-col>
            </el-form-item>
            <!-- <el-form-item
              v-if="
                member_card.base_info.date_info.type == 'DATE_TYPE_FIX_TERM'
              "
            >
              <div id="day-div">领取后<el-input></el-input>天内有效</div>
            </el-form-item> -->
            <el-form-item label="每人可领卡数量：">
              <el-input v-model="member_card.base_info.get_limit" placeholder="每人最多可领卡的数量"></el-input>
            </el-form-item>
            <el-form-item label="积分规则详情：">
              <div class="inline-div">
                <p style="display: inline; width: 100px; text-align: left">
                  初始积分：
                </p>
                <el-input v-model="member_card.bonus_rule.init_increase_bonus"></el-input>
              </div>
              <div class="inline-div">
                <p style="display: inline; width: 100px; text-align: left">
                  消费：
                </p>
                <el-input v-model="member_card.bonus_rule.cost_money_ubit"></el-input>
                <p style="width: 40px">元</p>
                获得<el-input v-model="member_card.bonus_rule.increase_bonus"></el-input>积分
              </div>
              <div class="inline-div">
                <p style="display: inline; width: 100px; text-align: left">
                  每使用：
                </p>
                <el-input v-model="member_card.bonus_rule.cost_bonus_unit"></el-input>
                <p style="width: 40px">积分</p>
                抵用<el-input v-model="member_card.bonus_rule.reduce_money"></el-input>元
              </div>
              <div class="inline-div">
                <p style="display: inline; width: 100px; text-align: left">
                  消费满：
                </p>
                <el-input v-model="member_card.bonus_rule.least_money_to_use_bonus"></el-input>元可享用折扣
              </div>
              <div class="inline-div">
                <p style="display: inline; width: 100px; text-align: left">
                  单次最多获取：
                </p>
                <el-input v-model="member_card.bonus_rule.max_increase_bonus"></el-input>积分
              </div>
              <div class="inline-div">
                <p style="display: inline; width: 100px; text-align: left">
                  单笔最多可用：
                </p>
                <el-input v-model="member_card.bonus_rule.max_reduce_bonus"></el-input>分
              </div>
              <div class="inline-div">
                <p style="display: inline; width: 100px; text-align: left">
                  会员可享：
                </p>
                <el-input v-model="member_card.discount"></el-input>折（填写（1）打99折,填写（10）打9折）
              </div>
              <div class="inline-div">
                <el-button @click="ruleChange" type="info" plain style="margin-right: 20px">
                  生成积分规则
                </el-button>
                <i style="color: #dc1f1f">需要先填写积分规则详情</i>
              </div>
            </el-form-item>
            <el-form-item label="积分规则介绍：">
              <el-input type="textarea" style="width: 350px" resize="none" :rows="6" placeholder=""
                v-model="member_card.bonus_rules">
              </el-input>
            </el-form-item>
          </el-form>
        </el-scrollbar>
        <div class="form-bottom">
          <el-button type="danger" @click="submit">保存会员信息</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// GetCardClassify, UpdateWxMemberCard,
import {
  wxServiceMembershipQuery,
  wxServiceMembershipSet,
  wxServiceGetCardList
} from "@/api/wxService.js";
import logo from "@/components/logo.vue";
export default {
  name: "vip",
  components: {
    logo
  },
  watch: {
    card_color: {
      handler(ncol, ocol) {
        this.bg_color = `background-color:${this.card_color}`;
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      gzhappid: "wxf003ddc051b4643b",
      moddle_data: {}, //用来存放中间值
      brand_name: "", //商户名
      bg_style: "",
      card_color: "#63B359",
      bg_src: "",
      // contents:['积分','等级','余额','优惠卷'],
      colorOptions: [
        {
          value: "Color010",
          label: "浅绿",
          color: "#63B359"
        },
        { value: "Color082", label: "黄绿", color: "#a9d92d" },
        {
          value: "Color020",
          label: "深绿",
          color: "#2c9f67"
        },
        {
          value: "Color030",
          label: "浅蓝",
          color: "#509fc9"
        },
        {
          value: "Color040",
          label: "深蓝",
          color: "#5885cf"
        },
        {
          value: "Color050",
          label: "紫色",
          color: "#9062c0"
        },
        { value: "Color060", label: "棕黄", color: "#d09a45" },
        { value: "Color070", label: "黄色", color: "#e4b138" },
        { value: "Color080", label: "橘黄", color: "#ee903c" },
        { value: "Color081", label: "橙黄", color: "#f08500" },
        { value: "Color090", label: "橘红", color: "#dd6549" },
        { value: "Color100", label: "红色", color: "#cc463d" },
        { value: "Color101", label: "暗红", color: "#cf3e36" },
        { value: "Color102", label: "蓝灰", color: "#5E6671" }
      ],
      cardOptions: [], //会员卡列表
      code_type_opetion: [
        { label: "文本", value: "CODE_TYPE_TEXT" },
        { label: "一维码 ", value: "CODE_TYPE_BARCODE" },
        { label: "二维码", value: "CODE_TYPE_QRCODE" },
        { label: "仅显示二维码", value: "CODE_TYPE_ONLY_QRCODE" },
        { label: "仅显示一维码", value: "CODE_TYPE_ONLY_BARCODE" },
        { label: "不显示任何码型", value: "CODE_TYPE_NONE" }
      ],
      bg_color: "",
      //business_service 商户服务类型
      businessServiceOptions: [
        {
          value: "BIZ_SERVICE_DELIVER",
          label: "外卖服务"
        },
        {
          value: "BIZ_SERVICE_FREE_PARK",
          label: "停车位"
        },
        {
          value: "BIZ_SERVICE_WITH_PET",
          label: "可带宠物"
        },
        {
          value: "BIZ_SERVICE_FREE_WIFI",
          label: "免费wifi"
        }
      ],
      wx_card_id: "",
      card_type: "MEMBER_CARD",
      member_card: {
        base_info: {
          get_limit: "", //每人可领卷的数量
          logo_url: "", //商户logo                        ❤
          code_type: "", //仅显二维码
          title: "", //卡卷名
          color: "", //卡卷颜色
          notice: "", //付款时请提前出示会员卡
          description: "", //会员卡每人限领1张，仅限本人使用卡卷使用说明                  ❤
          center_title: "", //微信支付
          center_sub_title: "", //买单送积分
          service_phone: "",

          custom_url_name: "", //跳转外链的名字            ❤
          custom_url: "", //url
          custom_url_sub_title: "", //显示在路口右侧的提示

          promotion_url_name: "", //营销场景自定义入口
          promotion_url: "", //入口跳转外链的地址链接
          promotion_url_sub_title: "", //显示在营销入口右侧的提示语。

          //使用日期
          date_info: {
            type: "",
            begin_timestamp: "", //时间戳
            end_timestamp: "" //时间戳
          } //使用日期
          // bind_openid: "" //是否指定用户领取
        },
        background_pic_url: "", //背景图片地址
        prerogative: "", //特权说明                       ❤
        bonus_cleared: "", //积分清零规则 文字说明
        bonus_rules: "", //积分规则 文字说明
        balance_rules: "", //储值说明
        bonus_rule: {
          cost_money_ubit: "", //消费金额（分）
          increase_bonus: "", //对应增加的积分
          max_increase_bonus: "", //积分上限
          init_increase_bonus: "", //初始设置积分
          cost_bonus_unit: "", //每使用x积分
          reduce_money: "", //抵扣多少元（分）
          least_money_to_use_bonus: "", //折扣条件
          max_reduce_bonus: "" //单笔最多使用积分
        }, //积分规则
        discount: "", //折扣
        auto_activate: false, //是否开通自动激活 ，设置为true时用户领取会员卡自动设置为激活， 详情见 自动激活
        wx_activate: true, //是否开通一键开卡 设置为true时，该卡将支持一键开卡详情见 一键开卡 。 该选项与activate_url互斥
        activate_url: "" //激活连接
      }
    };
  },
  async mounted() {
    this.getCardInfo();
    this.getCardList();
  },
  methods: {
    /**
     * 选择组件input事件
     * @param {Object|String} e 选择组件返回值
     * @param {"gzhappid"} key 哪个点击的选择组件 gzhappid-切换公众号id
     */
    radioGroup(e, key) {
      // console.log(e);
      this[key] = e;
      this.getCardList();
    },
    /**
     * 获取卡列表
     */
    async getCardList() {
      const res = await wxServiceGetCardList(this.gzhappid);
      this.cardOptions = [];
      if (res !== false) {
        for (var i = 0; i < res.length; i++) {
          this.cardOptions.push({
            wx_card_id: res[i],
            label: res[i]
          });
        }
      }
    },
    autoActivateChange(e) {
      /* if (e) {
        this.member_card.activate_url = "";
      } else {
        //TODO: 当auto_activate是假时赋值原来的active_url 给active_url
        this.member_card.activate_url = this.moddle_data.activate_url;
      } */
    },
    async getCardInfo() {
      const res = await wxServiceMembershipQuery();
      // console.log("会员卡信息", JSON.stringify(res));
      if (this.testR(res)) {
        const mdata = res.data.resp_data;
        this.card_type = mdata.card.card_type;
        this.member_card = mdata.card.member_card;
        this.moddle_data = mdata.card.member_card;
        //返回的是颜色 要转换成colorOptions里面的选项
        this.card_color = mdata.card.member_card.base_info.color;
        this.setCardColor(this.card_color);

        //没有bonus_rules 这个属性，这个属性需要自己加
        // this.member_card.bonus_rules = this.member_card.bonus_rules?this.member_card.bonus_rules:"";
        // this.member_card.bonus_rules = "";

        if (this.member_card.bonus_rules === undefined) {
          delete this.member_card.bonus_rules;
          this.$set(this.member_card, "bonus_rules", "");
        }
        this.$refs.logoRef.setImgSrc(this.member_card.base_info.logo_url);
      }
      // console.log("会员卡信息member_card", JSON.stringify(this.member_card));
    },

    /**
     * 提交修改内容
     */
    async submit() {
      var base_info = {};
      var date_info = {};
      var member_card = {};
      var bonus_rule = {};
      var advanced_info = {};
      for (let key in this.member_card.advanced_info) {
        if (
          this.member_card.advanced_info[key] !== "" ||
          this.member_card.advanced_info[key].length !== 0
        ) {
          if (key === "use_condition" || key === "share_friends") continue;
          advanced_info[key] = this.member_card.advanced_info[key];
        }
      }
      for (let key in this.member_card.base_info) {
        if (
          this.member_card.base_info[key] !== "" ||
          this.member_card.base_info[key].length !== 0
        ) {
          if (
            key === "sku" ||
            key === "use_all_locations" ||
            key === "date_info" ||
            key === "brand_name" ||
            key === "id" ||
            key === "status" ||
            key === "create_time" ||
            key === "update_time"
          ) { continue; }
          base_info[key] = this.member_card.base_info[key];
        }
      }
      // console.log("base_info里面的数据---------------------------",base_info);
      for (var key in this.member_card.base_info.date_info) {
        if (
          this.member_card.base_info.date_info[key] !== "" ||
          this.member_card.base_info.date_info[key].length !== 0
        ) {
          date_info[key] = this.member_card.base_info.date_info[key];
        }
      }
      if (date_info.type === "1") {
        base_info.date_info = date_info;
      }
      for (let key in this.member_card.bonus_rule) {
        if (
          this.member_card.bonus_rule[key] !== "" ||
          this.member_card.bonus_rule[key].length !== 0
        ) {
          bonus_rule[key] = this.member_card.bonus_rule[key];
        }
      }
      for (let key in this.member_card) {
        if (
          key === "base_info" ||
          key === "bonus_rule" ||
          key === "prerogative" ||
          key === "supply_balance" ||
          key === "advanced_info"
        ) { continue; }
        if (this.member_card[key] !== "" || this.member_card[key].length !== 0) {
          member_card[key] = this.member_card[key];
        }
      }
      if (JSON.stringify(bonus_rule) !== "{}" || bonus_rule.length > 0) { member_card.bonus_rule = bonus_rule; }
      if (JSON.stringify(base_info) !== "{}" || base_info.length > 0) { member_card.base_info = base_info; }
      // console.log("data--------------------", JSON.stringify(member_card));
      const result = await wxServiceMembershipSet(member_card);
      const resp = result.data.resp_data;
      //TODO: 修改接口返回现在失败
      console.log("修改接口返回", result);
      if (
        result.data &&
        resp &&
        resp.errcode === 0 &&
        resp.errmsg === "ok" &&
        resp.send_check
      ) {
        this.successMessage("会员卡修改成功！");
      } else if (result.data && resp && resp.errcode !== 0 && resp.errmsg) {
        this.warnMessage(resp.errmsg);
      }
      //
      /* var { data: res } = await UpdateWxMemberCard(data);
      console.log("修改会员卡的返回值：", res);
      if (res.return_code != "SUCCESS" || typeof res.return_msg == "string") {
        this.$message.error("修改失败" + res.return_msg);
        return;
      }
      if (res.result_code != "SUCCESS" || typeof res.result_msg == "string") {
        this.$message.error("修改失败" + res.result_msg);
        return;
      }
      if (
        res.return_code == "SUCCESS" &&
        res.result_code == "SUCCESS" &&
        JSON.parse(res.resp_data).errmsg == "ok"
      ) {
        this.successMessage("修改成功");
      } else if (
        res.return_code == "SUCCESS" &&
        res.result_code == "SUCCESS" &&
        JSON.parse(res.resp_data).errmsg != "ok"
      ) {
        this.$message.error("修改失败" + JSON.parse(res.resp_data).errmsg);
      } else {
        this.$message.error("修改失败");
      } */
    },
    ruleChange() {
      console.log("bonus_rules", this.member_card.bonus_rules);
      console.log("bonus_rules", this.member_card);
      try {
        this.member_card.bonus_rules =
          "激活送" +
          this.member_card.bonus_rule.init_increase_bonus +
          "积分\n每消费" +
          this.member_card.bonus_rule.cost_money_ubit +
          "元,获得" +
          this.member_card.bonus_rule.increase_bonus +
          "积分\n单次最多获取" +
          this.member_card.bonus_rule.max_increase_bonus +
          "积分\n" +
          "每使用" +
          this.member_card.bonus_rule.cost_bonus_unit +
          "积分，抵用" +
          this.member_card.bonus_rule.reduce_money +
          "元\n满" +
          this.member_card.bonus_rule.least_money_to_use_bonus +
          "元可用\n会员可享" +
          (100 - parseInt(this.member_card.discount)) / 10 +
          "折优惠";
      } catch (e) {
        console.log(e);
      }
      this.member_card.bonus_rules = this.member_card.bonus_rules
        .toString()
        .replace(/undefined/g, "  ");
      console.log("积分规则", this.member_card.bonus_rules);
    },
    //选择颜色事件改变
    setColor(e) {
      for (var i = 0; i < this.colorOptions.length; i++) {
        if (this.colorOptions[i].value === e) {
          this.card_color = this.colorOptions[i].color;
        }
      }
    },
    setCardColor(color) {
      for (let i = 0; i < this.colorOptions.length; i++) {
        if (this.colorOptions[i].color === color) {
          this.member_card.base_info.color = this.colorOptions[i].value;
        }
      }
    },

    /**
     * 返回图片路径
     * @param {tag:string,media_no:string}
     */
    getReturn({ tag, media_no }) {
      switch (tag) {
        case "logo":
          this.member_card.base_info.logo_url = media_no;
          // this.member_card.base_info.logo_url = media_no;
          break;
        case "bg":
          this.bg_src = media_no;
          // this.member_card.background_pic_url = media_no;
          this.member_card.background_pic_url = media_no;
          break;
      }
    },
    returnClose({ tag }) {
      switch (tag) {
        case "logo":
          // this.member_card.base_info.logo_url = "";
          this.member_card.base_info.logo_url = "";
          break;
        case "bg":
          this.bg_src = "";
          this.member_card.background_pic_url = "";
          this.bg_style = "";
          break;
      }
    },
    getDate(date, str) {
      this.member_card.base_info.date_info[str] = date.valueOf();
    }
  }
};
</script>
<style scoped>
#id-card {
  position: relative;
}

#id-card::before {
  content: "*";
  position: absolute;
  left: -10px;
  top: 10px;
  font-size: 20px;
  color: rgb(251, 24, 24);
}

.img-icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-right: 10px;
}

.el-form-item>>>.el-input {
  width: 350px !important;
}

#date-div>>>.el-input {
  width: 150px !important;
}

#day-div>>>.el-input {
  width: 150px !important;
  margin: 0 10px;
}

#day-div {
  color: #606266;
}

.inline-div>>>.el-input {
  width: 80px !important;
  padding: 0 !important;
  margin: 0 10px;
}

.inline-div {
  display: flex;
  justify-content: left;
  align-items: center;
  margin: 2px 0;
  color: #606266;
}

.father {
  height: 100%;
  width: 100%;
  position: relative;
  background-color: #fff;
  border-radius: 5px;
}

.el-breadcrumb {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 5px;
  margin-bottom: 0;
  font-size: 16px;
}

.div-main-form {
  display: inline-block;
  /* position: absolute; */
  width: 800px;
  height: 500px;
  /* background-color: rgba(255, 124, 124, 0.471); */
  margin-left: 100px;
}

.form-top {
  width: 94%;
  margin: 0 3% 0 3%;
  font-size: 20px;
  color: rgb(130, 130, 130);
  border-bottom: 1px solid #ccc;
}

.form-bottom {
  display: flex;
  justify-content: center;
}

.form-body {
  height: 100%;
}

.el-herf {
  padding-left: 20px;
  padding-right: 20px;
  color: rgb(110, 110, 110);
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  line-height: 3;
  display: flex;
  justify-content: space-between;
}

.el-herf-right {
  padding-left: 20px;
  padding-right: 20px;
  color: rgb(110, 110, 110);
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  line-height: 3;
  display: flex;
  justify-content: right !important;
}

.el-input {
  width: 200px !important;
}

.div-main-son {
  display: inline-block;
  width: 300px;
  height: 100%;
  margin-top: 40px;
  /* background-color: pink; */
}

.div-main-sonson {
  /* display: inline-block; */
  overflow: hidden;
  float: left;
  width: 320px;
  height: 660px;
  /* background-color: rgb(196, 255, 188); */
  border-radius: 30px;
  margin: 1%;
  transform: scale(0.85);
  margin-top: -85px;
}

.background-img {
  position: relative;
  top: 0;
  left: 0;
  border: 4px solid #000;
  border-top: 8px solid #000;
  border-bottom: 8px solid #000;
}

.div-camera {
  position: absolute;
  top: 0;
  left: 0;
  width: 310px;
  height: 65px;
  background: url("../../../../assets/pic/title1.png");
}

.div-camera-black {
  position: absolute;
  top: 0;
  left: 0;
  width: 321px;
  height: 55px;
  background-color: #000;
  background: url("../../../../assets/pic/title2.png") repeat-x;
}

.div-other-camera {
  position: absolute;
  top: 56px;
  width: 321px;
  height: 550px;
}

.div-other-img {
  position: relative;
  top: 1%;
  left: 4%;
  width: 90%;
  height: 160px;
  /* background-color: #9062c0; */
  border-radius: 8px;
  padding: 10px;
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 160px;
  /* background-color: #9062c0; */
  border-radius: 8px;
}

.div-other-center {
  float: left;
  width: 90%;
  height: 70px;
  margin: 10px 5%;
}

.div-other-center-items {
  display: inline-block;
  width: 33%;
  height: 96%;
  margin-top: 1px;
  line-height: 2;
  text-align: center;
  border-right: 1px solid #f5f5f5;
}

.div-main-father {
  position: absolute;
  top: 4%;
  left: 4%;
  height: 96%;
  width: 96%;

  background-color: #fff;
  padding: 5px;
  display: flex;
  /* float: left; */
}

.div-other-img-top {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
}

.div-other-img-btm-icon {
  position: absolute;
  right: 50px;
  bottom: 8px;
  text-align: center;
  line-height: 1.2;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  display: inline-block;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.367);
  border: 1px solid #fff;
  /* line-height: 2; */
}

.div-other-img-btm-icon::before {
  content: "i";
}

span {
  display: block;
}

.el-button-green {
  border: 1px solid rgb(5, 183, 5) !important;
}
</style>
